import React, { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketPixMessages = ({ dispatch }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handlePixMessage = (data) => {
        if ((["update", "create"].includes(data.action)) && (`${api.defaults.headers.tenantId.toString()}` === `${data.tenantId.toString()}`)) {
          dispatch({ type: "UPDATE_PIX_MESSAGES", payload: data.pixMessage });
        }

        if ((data.action === "delete") && (`${api.defaults.headers.tenantId.toString()}` === `${data.tenantId.toString()}`)) {
          dispatch({ type: "DELETE_PIX_MESSAGE", payload: data.pixMessageId });
        }
      };

      socket.on("pixMessage", handlePixMessage);

      return () => {
        socket.off("pixMessage", handlePixMessage);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);



  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketPixMessages;
